import {
  CircularProgress,
  FormControl,
  Grid,
  IconButton,
  makeStyles,
  MenuItem,
  Paper,
  Select,
  SwipeableDrawer,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import SelectFilter from './SelectFilter';
import VisibilityIcon from '@material-ui/icons/Visibility';
import CachedIcon from '@material-ui/icons/Cached';
import clsx from 'clsx';
import moment from 'moment';
import { warehouseData } from './warehouseData';
import PaginationInput from '../../../common/models/pagination/PaginationInput';
import ViewAssociatedTeamMembers from './ViewAssociatedTeamMembers';
import ViewAssociatedCDMOs from './ViewAssociatedCDMOs';
import ViewEditWarehouse from '../ViewEditWarehouses/ViewEditWarehouse';
import ViewWarehouse from '../ViewEditWarehouses/ViewWarehouse';

const useStyles = makeStyles((theme) => ({
  upload: {
    background:
      'transparent linear-gradient(251deg, #173072 0%, #301232 100%) 0% 0% no-repeat padding-box;',
    color: 'white',
    textTransform: 'none',
    borderRadius: '2rem',
    padding: '5px 20px',
    '&:hover': {
      backgroundColor: 'green',
      color: 'white',
    },
  },
  padR20: {
    paddingRight: 20,
    [theme.breakpoints.down('xs')]: {
      paddingRight: 0,
    },
  },
  refreshContainerSty: {
    display: 'flex',
    justifyContent: 'flex-end',
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'flex-start',
      paddingTop: '1rem',
    },
    [theme.breakpoints.down('xs')]: {
      paddingTop: '1rem',
    },
  },
  refreshSty: {
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  selectFilter: {
    minWidth: 200,
    marginRight: '1rem',
  },
  clearFilter: {
    cursor: 'pointer',
    color: '#286ACF',
    textDecoration: 'underline',
    whiteSpace: 'nowrap',
    marginLeft: '1rem',
    '&:hover': {
      textDecoration: 'none',
    },
  },
  tableContainer: {
    marginTop: theme.spacing(2),
  },
  addButton: {
    backgroundColor: '#C8DDFB',
    whiteSpace: 'nowrap',
    textTransform: 'none',
    '&:hover': {
      backgroundColor: '#C8DDFB',
    },
  },
  actionButton: {
    marginLeft: theme.spacing(1),
    border: '1px solid',
    borderRadius: 0,
    padding: '5px',
  },
  actionButtonDelete: {
    marginLeft: theme.spacing(1),
    border: '1px #FF0000 solid',
    borderRadius: 0,
    padding: '5px',
  },
  teamMembers: {
    color: '#286ACF',
    cursor: 'pointer',
    whiteSpace: 'nowrap',
    textDecoration: 'underline',
  },
  actionIcons: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  eyeIconSty: {
    border: '1px solid #7d7c7c',
    borderRadius: '4px',
    padding: '0.3rem',
    height: 'inherit',
    // marginLeft: '0.5rem',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: 'black',
      color: 'white',
      border: '1px solid #FFF',
    },
  },
  hgText: {
    fontWeight: 500,
    paddingRight: theme.spacing(1),
  },
  outlined: {
    padding: theme.spacing(1),
  },
  formControl: {
    minWidth: 120,
    fontSize: '0.875rem',
  },
}));

const renderStatusButton = (status) => {
  let color;
  switch (status) {
    case 'Active':
      color = '#4CAF50'; // Green for Completed
      break;
    case 'Inactive':
      color = '#FF0000'; // Grey for Awaiting Start
      break;
    default:
      color = '#000';
  }
  return (
    <Typography
      variant='body1'
      style={{
        textAlign: 'center',
        padding: '0.25rem',
        borderRadius: '0.45rem',
        fontSize: '0.875rem',
        color: 'white',
        backgroundColor: color,
        border: `2px solid ${color}`,
        whiteSpace: 'nowrap',
      }}
    >
      {status ? status : 'NA'}
    </Typography>
  );
};

const WarehousesTable = () => {
  const classes = useStyles();
  const [statusFilter, setStatusFilter] = useState('All'); // State for statusFilter filter
  const [warehouseTable, setWarehouseTable] = useState([]);
  const [noRowsPerPage, setRowsPerPage] = useState(5);
  const [currentPage, setCurrentPage] = useState(1);
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(true);
  const [openDialogBox, setOpenDialogBox] = useState({
    open: false,
    type: '',
    parameter: null,
  });

  const callWarehousesAPI = () => {
    // axios
    // .post(
    //   `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchQAExceptionDetails`,
    //   data
    // )
    // .then((res2) => {
    //   if (res2.data.status) {

    //   } else {

    //   }
    // })
    // .catch((err) => {
    //   console.log(err);
    // });
    setWarehouseTable(warehouseData);
    setLoading(false);
  };

  useEffect(() => {
    setTimeout(() => {
      callWarehousesAPI();
    }, 3000)
  }, []);

  const handleRefresh = () => {
    setLoading(true);
    setTimeout(() => {
      callWarehousesAPI();
    }, 3000)
  };

  const handleStatusChange = (event) => {
    setStatusFilter(event.target.value);
  };

  const clearFilter = () => {
    setStatusFilter('All');
  };

  const statuses = [
    {
      StatusId: 1,
      statusName: 'Active',
    },
    {
      StatusId: 2,
      statusName: 'Inactive',
    },
  ];
  const handleSetRows = (event) => {
    setRowsPerPage(event.target.value);
  };

  const tableData = warehouseTable;

  let totalPages = Math.ceil(tableData.length / noRowsPerPage);

  let records = currentPage * noRowsPerPage;

  const warehousesTableData = tableData
    ? tableData.slice(records - noRowsPerPage, records)
    : [];

  const handlePageChange = (data) => {
    setCurrentPage(data);
  };

  const handleOpenDialogBox = (type, value) => {
    setOpenDialogBox({
      open: !openDialogBox.open,
      type: type,
      parameter: value ? value : null,
    });
  };

  const handleCloseDialogBox = () => {
    setOpenDialogBox({
      open: false,
      type: '',
      parameter: null,
    });
  };

  return (
    <React.Fragment>
      <Grid
        container
        alignItems='center'
        justifyContent='space-between'
        style={{ paddingBottom: '0.5rem', paddingTop: '1rem' }}
      >
        <Grid item xs={12} md={3}>
          <Typography
            variant='body2'
            style={{ fontWeight: 500, marginBottom: '0.5rem' }}
          >
            Status
          </Typography>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <SelectFilter
              value={statusFilter}
              handleSelect={handleStatusChange}
              objectArray={statuses}
            />
            <Typography
              variant='caption'
              className={classes.clearFilter}
              onClick={clearFilter}
            >
              Clear filter
            </Typography>
          </div>
        </Grid>

        <Grid item xs={12} md={6}>
          <Grid container className={classes.refreshContainerSty}>
            <Typography variant='caption' className={clsx(classes.padR20)}>
              {`Last synced @ ${moment(new Date()).format(
                'HH:mm:ss; DD MMMM, YYYY'
              )}`}
            </Typography>

            <Typography
              variant='caption'
              color='primary'
              className={classes.refreshSty}
              onClick={handleRefresh}
            >
              Refresh
              <CachedIcon
                color='primary'
                style={{ fontSize: 15, marginLeft: '0.25rem' }}
              />
            </Typography>
          </Grid>
          <Grid container alignItems='center' justifyContent='flex-end'>
            <Grid item>
              <Typography variant='body2' className={classes.hgText}>
                PER PAGE
              </Typography>
              <FormControl className={classes.formPerPage}>
                <Select
                  labelId='perpage-filter'
                  id='perpage-filter-id'
                  value={noRowsPerPage}
                  variant='outlined'
                  onChange={handleSetRows}
                  classes={{
                    outlined: classes.outlined,
                  }}
                >
                  <MenuItem value={3}>3</MenuItem>
                  <MenuItem value={5}>5</MenuItem>
                  <MenuItem value={10}>10</MenuItem>
                  <MenuItem value={15}>15</MenuItem>
                  <MenuItem value={30}>30</MenuItem>
                </Select>
              </FormControl>
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      <TableContainer component={Paper} className={classes.tableContainer}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell
                align='left'
                style={{ whiteSpace: 'nowrap', fontWeight: 500 }}
              >
                Warehouse name
              </TableCell>
              <TableCell
                align='left'
                style={{ whiteSpace: 'nowrap', fontWeight: 500 }}
              >
                ID
              </TableCell>
              <TableCell
                align='left'
                style={{ whiteSpace: 'nowrap', fontWeight: 500 }}
              >
                Associated team members
              </TableCell>
              <TableCell
                align='left'
                style={{ whiteSpace: 'nowrap', fontWeight: 500 }}
              >
                Associated CMOs
              </TableCell>
              <TableCell
                align='center'
                style={{ whiteSpace: 'nowrap', fontWeight: 500 }}
              >
                Status
              </TableCell>
              <TableCell
                align='center'
                style={{ whiteSpace: 'nowrap', fontWeight: 500 }}
              >
                Actions
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {loading ? (
              <TableRow style={{ height: 150 }}>
                <TableCell colSpan={6}>
                  <div style={{ textAlign: 'center' }}>
                    <CircularProgress color='primary' />
                  </div>
                </TableCell>
              </TableRow>
            ) : error ? (
              <TableRow
                style={{
                  border: '2px solid #FF0000',
                  backgroundColor: '#FFF0F0',
                }}
              >
                <TableCell colSpan={6} align='center'>
                  Something went wrong. Please try again later.
                </TableCell>
              </TableRow>
            ) : warehousesTableData.length === 0 ? (
              <TableRow>
                <TableCell colSpan={6} align='center'>
                  No Records Found
                </TableCell>
              </TableRow>
            ) : (
              warehousesTableData.map((val, index) => (
                <TableRow key={index}>
                  <TableCell align='left'>
                    <Typography style={{ fontWeight: 500 }}>
                      {`${val.warehouseName}`}
                    </Typography>
                    <Typography style={{ maxWidth: '400px' }}>
                      {val.warehouseMainAddress}
                    </Typography>
                  </TableCell>
                  <TableCell align='left'>
                    <Typography>{`${val.warehouseCode}`}</Typography>
                  </TableCell>
                  <TableCell align='left'>
                    <Typography
                      style={{ whiteSpace: 'nowrap' }}
                      className={classes.teamMembers}
                      onClick={() =>
                        handleOpenDialogBox('associatedTeamMembers', val)
                      }
                    >
                      {Array.isArray(val.associatedTeamMembers)
                        ? `${val.associatedTeamMembers.length} ${
                            val.associatedTeamMembers.length > 1
                              ? 'team members'
                              : 'team member'
                          }`
                        : ' NA '}
                    </Typography>
                  </TableCell>
                  <TableCell align='left'>
                    <Typography
                      style={{ whiteSpace: 'nowrap' }}
                      className={classes.teamMembers}
                      onClick={() =>
                        handleOpenDialogBox('associatedCDMOs', val)
                      }
                    >
                      {Array.isArray(val.associatedCDMOs)
                        ? `${val.associatedCDMOs.length} ${
                            val.associatedCDMOs.length > 1 ? 'CMOs' : 'CMO'
                          }`
                        : ' NA '}
                    </Typography>
                  </TableCell>
                  <TableCell align='center'>
                    <Typography style={{ whiteSpace: 'nowrap' }}>
                      {renderStatusButton(val.status)}
                    </Typography>
                  </TableCell>
                  <TableCell align='center'>
                    <div className={classes.actionIcons}>
                      <IconButton
                        disableRipple
                        disableFocusRipple
                        disableTouchRipple
                        style={{ padding: 0, borderRadius: 0 }}
                        onClick={() =>
                          handleOpenDialogBox('viewEditWarehouse', val)
                        }
                      >
                        <VisibilityIcon className={classes.eyeIconSty} />
                      </IconButton>
                    </div>
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <PaginationInput
        totalPages={totalPages}
        handlePageChange={handlePageChange}
        page={currentPage}
      />

      {openDialogBox.type !== '' && (
        <SwipeableDrawer
          anchor={'right'}
          open={openDialogBox.open}
          onClose={() => handleCloseDialogBox()}
          onOpen={() => handleOpenDialogBox(openDialogBox.type)}
        >
          {openDialogBox.type === 'associatedTeamMembers' && (
            <ViewAssociatedTeamMembers
              handleClose={() => handleCloseDialogBox()}
              warehouseDetails={openDialogBox.parameter}
            />
          )}
          {openDialogBox.type === 'associatedCDMOs' && (
            <ViewAssociatedCDMOs
              handleClose={() => handleCloseDialogBox()}
              warehouseDetails={openDialogBox.parameter}
            />
          )}
          {openDialogBox.type === 'viewEditWarehouse' && (
            // <ViewEditWarehouse />
            <ViewWarehouse warehouseDetails={openDialogBox.parameter} 
            handleRefresh = {handleRefresh} 
            closeView={() => handleCloseDialogBox()}
            />
          )}
        </SwipeableDrawer>
      )}
    </React.Fragment>
  );
};

export default WarehousesTable;
